if (!customElements.get('rd-product-pair')) {
  customElements.define('rd-product-pair', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button = this.querySelector('button');
      this.message = this.querySelector('[role="alert"]');
      this.basketLink = this.querySelector('.rd-product-pair__basket');
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.addPair(), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async addPair() {
      if (this.busy) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.message.hidden = true;
      this.basketLink.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      const cartUrl = `${root}cart`;
      let added = false;

      try {
        const items = Array.from(this.querySelectorAll('[data-pair-variant]'), input => ({ id: Number(input.value), quantity: 1 }));
        const sections = [];
        this.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const requestedSections = [...new Set(sections)].slice(0, 5);
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: requestedSections, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        added = true;

        if (window.themeVariables?.settings?.cartType !== 'drawer' || !requestedSections.length || requestedSections.some(id => typeof result.sections?.[id] !== 'string')) {
          window.location.assign(cartUrl);
          return;
        }

        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items, cart } }));
        this.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
      } catch (error) {
        if (added) {
          window.location.assign(cartUrl);
          return;
        }
        this.message.textContent = error.message || this.dataset.error;
        this.message.hidden = false;
        this.basketLink.hidden = false;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}
